const initialState = {
  meta: [],
  collection: [],
  pending_events: [],
  pollResults: {
    data: {
      spots: [],
      top_spots: []
    },
    loading: false,
    error: false
  },
  pollBooking: {
    name: '',
    invitees: [],
    additionalInvitees: [],
    startTime: null,
    endTime: null,
    eventTypeId: null,
    locationConfiguration: null,
    hasEventConflict: false,
    modalVisible: false,
    isLoading: false
  },
  export: {
    loading: false,
    disabled: false,
    error: null,
    timeoutTimerId: null
  },
  filters_error: null,
  showFiltersBar: false,
  showBuffers: true,
  popups: {
    export_confirmation: false
  },
  bookMeetingWithContact: {
    isShareStarted: false,
    sharedContact: null
  },
  editBufferPopup: {
    isOpen: false,
    event: {},
    userMembership: {},
    type: null,
    isMultiHost: false
  }
}

// ##############################################################################

const getNoShowInviteesCount = (event) => (
  event.invitees.collection.filter(({ no_show: noShow }) => noShow).length
)

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FILTERS_ERROR':
      return {
        ...state,
        filters_error: action.payload.type
      }
    case 'CLEAR_FILTERS_ERROR':
      return {
        ...state,
        filters_error: null
      }
    case 'EXPORT_EVENTS_SHOW_CONFIRMATION':
      return {
        ...state,
        popups: {
          export_confirmation: true
        }
      }
    case 'EXPORT_EVENTS_DISMISS_CONFIRMATION':
      return {
        ...state,
        popups: {
          export_confirmation: false
        }
      }
    case 'EXPORT_EVENTS_REQUEST':
      return {
        ...state,
        export: { ...state.export, loading: true }
      }
    case 'EXPORT_EVENTS_DONE':
      return {
        ...state,
        export: { ...state.export, loading: false }
      }
    case 'EXPORT_EVENTS_SET_ERROR':
      return {
        ...state,
        export: { ...state.export, error: action.payload.error }
      }
    case 'EXPORT_EVENTS_CLEAR_ERROR':
      return {
        ...state,
        export: { ...state.export, error: null }
      }
    case 'CHANGE_FILTERS_BAR_VISIBILITY':
      return {
        ...state,
        ...action.payload
      }
    case 'SET_SHOW_BUFFERS':
      return {
        ...state,
        ...action.payload
      }
    case 'DISABLE_EXPORT_EVENTS':
      return {
        ...state,
        export: {
          ...state.export,
          disabled: true,
          timeoutTimerId: action.payload.timerId
        }
      }
    case 'ENABLE_EXPORT_EVENTS':
      return {
        ...state,
        export: {
          ...state.export,
          disabled: false,
          timeoutTimerId: null
        }
      }
    case 'SET_SCHEDULED_EVENTS_LOADING':
      return {
        ...state,
        loading: action.payload,
        activeEventId: null
      }
    case 'INIT_SCHEDULED_EVENTS_RESULTS':
      // TODO: Make backend response to return invitee as single item array
      return {
        ...state,
        meta: action.payload.meta,
        collection: action.payload.collection.map(
          (group) => ({
            ...group,
            events: group.events.map(
              (event) => {
                const { invitee, ...rest } = event
                return ({
                  ...rest,
                  timelineLoadingState: 'initial',
                  inviteeLoadingState: 'initial',
                  invitees: (
                    (event.invitee) ? {
                      collection: [invitee]
                    } : {
                      collection: []
                    }
                  )
                })
              }
            )
          })
        ),
        pagination: action.payload.pagination
      }
    case 'INIT_PENDING_EVENTS_RESULTS':
      return {
        ...state,
        pending_events: action.payload.collection,
        pagination: action.payload.pagination
      }
    case 'SET_PENDING_EVENT_CANCELED':
      return {
        ...state,
        pending_events: state.pending_events.map((event) => ({
          ...event,
          selected: null,
          isCanceled: event.isCanceled || (event.pending_id === action.payload)
        }))
      }
    case 'FETCH_POLL_RESULTS':
      return {
        ...state,
        pollResults: {
          ...state.pollResults,
          loading: true
        }
      }
    case 'FETCH_POLL_RESULTS_LOADED':
      return {
        ...state,
        pollResults: {
          ...state.pollResults,
          data: action.payload,
          loading: false,
          error: false
        }
      }
    case 'FETCH_POLL_RESULTS_FAILED':
      return {
        ...state,
        pollResults: {
          ...state.pollResults,
          loading: false,
          error: true
        }
      }
    case 'OPEN_POLL_BOOKING_MODAL':
      return {
        ...state,
        pollBooking: {
          ...state.pollBooking,
          ...action.payload,
          modalVisible: true
        }
      }
    case 'CLOSE_POLL_BOOKING_MODAL':
      return {
        ...state,
        pollBooking: {
          ...initialState.pollBooking
        }
      }
    case 'SET_POLL_BOOKING_MODAL_INVITEES':
      return {
        ...state,
        pollBooking: {
          ...state.pollBooking,
          invitees: action.payload
        }
      }
    case 'SET_POLL_BOOKING_MODAL_ADDITIONAL_INVITEES':
      return {
        ...state,
        pollBooking: {
          ...state.pollBooking,
          additionalInvitees: action.payload
        }
      }
    case 'ADD_POLL_ADDITIONAL_INVITEE':
      return {
        ...state,
        pollBooking: {
          ...state.pollBooking,
          additionalInvitees: [
            ...state.pollBooking.additionalInvitees,
            action.payload
          ]
        }
      }
    case 'SET_POLL_BOOKING_MODAL_LOADING':
      return {
        ...state,
        pollBooking: {
          ...state.pollBooking,
          isLoading: true
        }
      }
    case 'SET_POLL_BOOKING_MODAL_LOADING_COMPLETE':
      return {
        ...state,
        pollBooking: {
          ...state.pollBooking,
          isLoading: false
        }
      }
    case 'CLEAR_SCHEDULED_EVENTS_EDITING':
      return {
        ...state,
        collection: state.collection.map(
          (group) => ({
            ...group,
            events: group.events.map(
              (event) => ({
                ...event,
                invitees: {
                  ...event.invitees,
                  collection: event.invitees.collection.map(
                    (invitee) => ({
                      ...invitee,
                      editing: false
                    })
                  )
                }
              })
            )
          })
        )
      }
    case 'UPDATE_EVENT':
      return {
        ...state,
        collection: state.collection.map(
          (group) => ({
            ...group,
            events: group.events.map(
              (event) => (
                event.id === action.payload.id ? {
                  ...event,
                  ...action.payload
                } : event
              )
            )
          })
        )
      }
    case 'UPDATE_PENDING_EVENT':
      return {
        ...state,
        pending_events: state.pending_events.map(
          (event) => (
            event.pending_id === action.payload.id ? {
              ...event,
              ...action.payload
            } : event
          )
        )
      }
    case 'SET_EVENT_INVITEES':
      return {
        ...state,
        collection: state.collection.map(
          (group) => ({
            ...group,
            events: group.events.map(
              (event) => ({
                ...event,
                invitees: (
                  event.id === action.payload.eventId
                    ? action.payload.data
                    : event.invitees
                )
              })
            )
          })
        )
      }
    case 'UPDATE_INVITEE':
      return {
        ...state,
        collection: state.collection.map(
          (group) => ({
            ...group,
            events: group.events.map(
              (event) => ({
                ...event,
                invitees: {
                  ...event.invitees,
                  collection: event.invitees.collection.map(
                    (invitee) => (
                      invitee.id === action.payload.id ? {
                        ...invitee,
                        ...action.payload
                      } : invitee
                    )
                  )
                }
              })
            )
          })
        )
      }
    case 'UPDATE_NO_SHOW_INVITEES_COUNT':
      return {
        ...state,
        collection: state.collection.map(
          (group) => ({
            ...group,
            events: group.events.map(
              (event) => (
                event.id === action.payload.eventId ? {
                  ...event,
                  no_show_invitees_count: getNoShowInviteesCount(event)
                } : event
              )
            )
          })
        )
      }
    case 'SET_ACTIVE_EVENT_LIST_ITEM':
      return {
        ...state,
        activeEventId: action.payload.id
      }
    case 'SET_RESERVED_TIMES_EMPTY':
      return {
        ...state,
        pending_events: state.pending_events.map((event) => ({
          ...event,
          grouped_reserved_time_spots: event.pending_id === action.payload ? [] : event.grouped_reserved_time_spots
        }))
      }
    case 'SET_BOOKMEETING_WITH_CONTACT':
      return {
        ...state,
        bookMeetingWithContact: {
          isShareStarted: action.payload.isShareStarted,
          sharedContact: action.payload.sharedContact
        }
      }
    case 'OPEN_EDIT_BUFFER_POPUP':
      return {
        ...state,
        editBufferPopup: {
          isOpen: true,
          ...action.payload
        }
      }

    case 'CLOSE_EDIT_BUFFER_POPUP':
      return {
        ...state,
        editBufferPopup: initialState.editBufferPopup
      }

    default:
      return state
  }
}
